import(/* webpackMode: "eager" */ "/app/packages/web/app/page.tsx");
